<div class="db-copy-website-purpose">

  <div *ngIf="!(ongoingGoogleScoreActivity$ | async) && !loading">
    <div class="db-copy-website-purpose-body" id="db-copy-website-purpose-body">
      <div class="header-title" *ngIf="isMobile">
        {{'text_score.check.title' | dbText }}
      </div>

      <div class="db-score-response-error" *ngIf="failedResponse && scores[0].value !== null && scores[0].value !==
      101">
        <div class="db-score-response-error-image">
          <img src="assets/images/icons/error-info.svg" alt=""/>
        </div>
        <div class="db-score-response-error-text">
          <div class="db-score-response-error-text-title">{{'text_somethingWentWrongDot' | dbText }}</div>
          <div class="db-score-response-error-text-desc">{{'text_score.error.desc' | dbText }}</div>
        </div>
      </div>

      <div class="db-copy-request-sent" *ngIf="website?.manualMigrationStatus &&
      ['accepted', 'in_progress'].includes(website?.manualMigrationStatus) && !website?.domain_hash &&
      scores[0].value !== null && scores[0].value !== 101">
        <div class="db-copy-request-sent-image">
          <img src="assets/images/icons/letter.svg" alt=""/>
        </div>
        <div class="db-copy-request-sent-text">
          <div class="db-copy-request-sent-text-desc">{{'text_score.website.copy' | dbText }}</div>
        </div>
      </div>

      <div class="db-move-to-10web__sup-title" *ngIf="!website?.domain_hash && scores[0].value !== null &&
      scores[0].value >= 90 && scores[0].value !== 101">Wow!</div>
      <div class="db-move-to-10web__title" *ngIf="!website?.domain_hash && scores[0].value !== null &&
      scores[0].value >= 90 && scores[0].value !== 101">You’ve Done a Great Job Optimizing Your Website!</div>
      <div class="db-move-to-10web__sup-title" *ngIf="!website?.domain_hash && scores[0].value !== null &&
      scores[0].value < 90 && scores[0].value !== 101">{{'text_score.low' | dbText }} <img
        src="assets/images/emojis/thinking_face.png"
                                                                  alt=""/> </div>
      <div class="db-move-to-10web__title" *ngIf="!website?.domain_hash && scores[0].value !== null &&
      scores[0].value < 90 && scores[0].value !== 101" [innerHTML]="'text_score.low.desc' | dbText"></div>
      <div class="db-move-to-10web__sup-title" *ngIf="scores[0].value === null || scores[0].value === 101">We Were
        Unable to Check Your
        Score</div>
      <div class="db-move-to-10web__title" *ngIf="(scores[0].value === null || scores[0].value === 101) &&
      website?.domain_hash">Please Contact
        Us to Resolve the Issue</div>
      <div class="db-move-to-10web__title" *ngIf="(scores[0].value === null || scores[0].value === 101) && !website?.domain_hash">Please Check If Your Website Works Properly &<br> Try Again in a Day or Contact Us</div>
      <div class="db-move-to-10web__title" *ngIf="website?.domain_hash && !website?.isMigrated && userSubscription.type === userSubscriptionTypes.FREE" [innerHTML]="'text_copyWebsitePageTitle' | dbText"></div>

      <!--START SCORE SECTION-->
      <div class="db-move-to-10web__score-section-scores-content">
        <div class="db-move-to-10web__score-section-scores-info" *ngIf="scores[0].value === null || scores[0].value === 101">
          <div class="db-move-to-10web__score-section-scores-info-item">
            <div class="db-score-circle">
              <div class="db-score-error"><i class="db-icon db-icon-information"></i></div>
            </div>
            <div class="db-score-desc-small">
              <div>
                <a class="db-google-score-site-url" [href]="website?.site_url" target="_blank" rel="noopener"
                   [dbTooltipPosition]="'bottom'" [dbTooltip]="website?.site_url">
                  {{website?.site_url}}
                </a>
                <div>
                  <b class="db-load-time-small">{{'text_moveTo10web.loadTime' | dbText}}: &mdash; &mdash;</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="db-move-to-10web__score-section-scores-info" *ngIf="(scores[0].value !== null && scores[0].value
        !== 101) && (scores[1].value !== null && scores[1].value !== 101)">
          <div class="db-move-to-10web__score-section-scores-info-item" *ngFor="let score of scores">
            <div class="db-score-circle">
              <div class="db-score-number" [ngClass]="{'db-score-number-yellow': score.value >= 50 && score.value < 90, 'db-score-number-red': score.value >= 0 &&  score.value < 50, 'db-score-max': score.value === 100, 'db-score-single': score.value < 10}">{{score.value}}</div>
              <svg viewBox="0 0 120 120" *ngIf="score.value !== null">
                <circle class="db-bg-stroke" [ngClass]="{'db-stroke-yellow': score.value >= 50 && score.value < 90, 'db-stroke-red': score.value >= 0 &&  score.value < 50}" r="56" cx="60" cy="60"></circle>
                <circle class="db-score-stroke" [ngClass]="{'db-score-stroke-yellow': score.value >= 50 && score.value < 90, 'db-score-stroke-red': score.value >= 0 && score.value < 50 }" transform="rotate(-90 60 60)" r="56" cx="60" cy="60" attr.stroke-dasharray="{{radiusScore - (radiusScore * (1-((score.value) / 100)))}}, {{radiusScore}}"></circle>
              </svg>
            </div>
            <div class="db-score-desc">
              <div>
                <p class="db-google-score-site-url">{{score.name}}</p>
                <div *ngIf="score.loadTime">
                  <b class="db-load-time">{{'text_moveTo10web.loadTime' | dbText}}: {{score.loadTime}}s</b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="db-score-separator"></div>

        <div class="db-recheck-buttons-wrap">
          <p class="db-recheck-button"> To test your website again, press
            <a class="db-recheck-more-info-link" (click)="retry()"><span>Recheck</span></a>
          </p>
          <p class="db-score-check-tools">You can always check your score with <br>
            <a class="db-link-blue" target="_blank" rel="noopener" href="https://developers.google.com/speed/pagespeed/insights/"><span>Google PageSpeed Insights</span></a> or <a class="db-link-blue" target="_blank" rel="noopener" href="https://gtmetrix.com"><span>GTMetrix</span></a></p>
        </div>
      </div>
      <!--END SCORE SECTION-->

      <div *ngIf="website?.domain_hash && optimizerPlugin && !optimizerPlugin.active && !optimizerLoading &&
      scores[0].value !== null && scores[0].value !== 101"
           class="db-google-insights__migrated-low-score" >
        <div>
          <div>
            <img src="assets/images/icons/info-red.svg" class="db-low-score-information" alt=""/>
            <p [innerHTML]="'text_optimizerPluginInstall' | dbText"></p>
          </div>
          <a class="db-button db-button_success" (click)="installOptimizerPlugin()"><span>{{'text_migrationFlowLowScoreOptimize' | dbText}}</span></a>
        </div>
      </div>

      <db-move-to10web-hosted *ngIf="website?.domain_hash && scores[0].value !== null && scores[0].value !== 101 "
                              [desktopScore]="scores[0].value"
                              [domains]="domains"
                              [manualOptimize]="manualOptimize"
                              [websiteId]="website?.id"
                              [isTrial]="userSubscription?.type === userSubscriptionTypes.FREE"
                              [isMobile]="isMobile"
                              [isMigrated]="website?.isMigrated"
                              [activeOptimizer]="optimizerPlugin && optimizerPlugin.active"
      ></db-move-to10web-hosted>

      <db-move-to10web-connected *ngIf="!website?.domain_hash && scores[0].value !== null && scores[0].value !== 101"
                                 [desktopScore]="scores[0].value"
                                 (migrate)="migrate()"
      ></db-move-to10web-connected>

      </div>
  </div>


  <div class="db-google-score-loading" *ngIf="(ongoingGoogleScoreActivity$ | async) || loading">
    <div>
      <div class="db-google-score-loading-desc">Your Website is Being Analyzed</div>
      <div class="db-google-score-loading-title">Let's See How Fast Your Website Is <span><img src="assets/images/emojis/wink.png" alt=""/></span></div>

      <div class="db-google-score-loading-bar">
        <div class="db-google-score-loading-bar-title">Analyzing</div>
        <db-progress-bar class="db-google-score-loading__progress" [size]="'sm'" [progressPercent]="_activityProgress"></db-progress-bar>
        <div class="db-google-score-loading-bar-number">{{_activityProgress}}% complete</div>
      </div>
    </div>
  </div>
  <db-loading-screen [ngClass]="{'hidden':!optimizerLoading}" [pageBlocker]="true"></db-loading-screen>
</div>
